var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.659 2.00118L16.0353 1.76599H15.5916H2.01582H1.57204L1.94836 2.00118L8.73624 6.24361L8.80369 6.28577L8.87115 6.24361L15.659 2.00118ZM15.5916 12.2023H15.7188V12.0751V3.59023V3.36059L15.5241 3.4823L8.80369 7.68256L2.08327 3.4823L1.88854 3.36059V3.59023V12.0751V12.2023H2.01582H15.5916ZM15.5916 0.323562C16.4546 0.323562 17.1613 1.03022 17.1613 1.89326V12.0751C17.1613 12.9381 16.4546 13.6448 15.5916 13.6448H2.01582C1.15277 13.6448 0.44612 12.9381 0.44612 12.0751V1.89326C0.44612 1.03022 1.15277 0.323562 2.01582 0.323562H15.5916Z",
    fill: "#858585",
    stroke: "white",
    strokeWidth: 0.254545
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.a300a838be9664a93427b7f8f8b24c94.svg";
export { ForwardRef as ReactComponent };